
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.995 2.05C5.945 2.554 2 6.816 2 12c0 5.523 4.477 10 10 10 1.945 0 3.76-.555 5.295-1.515l-6.3-8.144V2.05zm7.903 17.19A9.972 9.972 0 0021.95 13h-7.86l4.807 6.24zM13.04 11V2.054A10.003 10.003 0 0121.951 11h-8.91zm8.96 1l-.001.05v-.1.05z"}})])
          )
        }
      }
    